module.exports = __webpack_public_path__ + "img/thermometer-title-m.1ad0274b.png";